export default "/images/logo2.png?83c261ee651e4c3f9a28aa9a9135ce2a";